import { useMemo, useState } from "react"

import { useParams } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { AddIcon } from "@l2r-front/l2r-icons"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { BottomSheet, L2RButton, ListItemIcon } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../constants/i18n"

import { getMenuConfig } from "./AddDocumentButton"
import * as Styled from "./AddDocumentButton.styled"

export function AddDocumentButtonMobile(props) {

    const {
        className,
        onAddDocumentMenuSelected,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)
    const { road } = useParams()

    const [open, setOpen] = useState(false)

    const MenuItems = useMemo(() => {
        return getMenuConfig(onAddDocumentMenuSelected, road, t)
            ?.filter(menuItem => menuItem.enabled)
            ?.map((menuItem, index) => {
                const handleClick = (event) => {
                    setOpen(false)
                    event.stopPropagation()
                    if (menuItem.props?.onClick) {
                        menuItem.props.onClick(event)
                    }
                }
                return <Styled.MenuItem key={index} id={menuItem.id}  {...menuItem.props} onClick={handleClick}>
                    {menuItem.icon && <ListItemIcon>
                        {menuItem.icon}
                    </ListItemIcon>
                    }
                    <Styled.ListItemText>
                        {menuItem.label}
                    </Styled.ListItemText>
                </Styled.MenuItem>
            })
    }, [onAddDocumentMenuSelected, road, t])

    return <div className={className}>
        <L2RButton shape="circle" size="small" id="mobile-filters-button" onClick={() => setOpen(true)}>
            <AddIcon />
        </L2RButton>
        <BottomSheet
            disableDiscovery
            disableBackdropTransition
            disableSwipeToOpen
            disableEnforceFocus
            onClose={() => setOpen(false)}
            open={open}>
            <Styled.ContentWrapper>
                {MenuItems}
            </Styled.ContentWrapper>
        </BottomSheet>
    </div>
}

AddDocumentButtonMobile.propTypes = {
    className: PropTypes.string,
    onAddDocumentMenuSelected: PropTypes.func.isRequired,
}
